import { useQuery } from '@tanstack/react-query';

import {
  getInsurancePolicyById,
  type GetInsurancePolicyByIdResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from './../queryKeys';

export default function usePolicy(
  policyId: string,
  options?: QueryOptions<GetInsurancePolicyByIdResponse>,
) {
  return useQuery({
    queryKey: queryKeys.policies.byId(policyId),
    queryFn: () =>
      getInsurancePolicyById(
        { path: { insurance_policy_id: policyId } },
        wgApi,
      ),
    ...options,
  });
}
